const elementary = require('../vendor/elementary.js');

const axios = require('axios');

const selector = "[data-filtered-events-list]";
let views      = [];

let els     = null;
let baseUrl = "";

function FilteredEventsLists(siteBaseUrl) {

	// Search for carousel elements on page
	els = document.querySelectorAll(selector);

	// If there are any, continue
	if (els.length) {
		baseUrl = siteBaseUrl;
		init();
	}
}

const init = () => {

	views = [
		{
			id: "grid",
			name: gridViewText
		},
		{
			id: "calendar",
			name: calendarViewText
		}
	];

	// Loop through each filters set
	[].forEach.call(els, function(item) {

		const viewType = item.dataset.filteredEventsList;

		// Listen for any change events inside filters
		item.addEventListener("filter-change", function(e) {
			
			console.log(e);

			// Don't automatically get events when "pick-a-date" chosen. Need to wait for selected date event.
			if (e.detail !== "pick-a-date") {
				getEvents(item);
			}
		});

		// Listen for when specific date chosen
		item.addEventListener("date-chosen", function(e) {
			console.log(e);
			item.dataset.dateChosen = true;
			getEvents(item);
		});

		// Listen for when specific date closed
		item.addEventListener("date-closed", function(e) {
			item.dataset.dateChosen = false;
			getEvents(item);
		});

		// Listen for view change click
		item.addEventListener("view-change-click", function(e) {
			
			// Call to load events
			switchView(item);
		});
	});
}

const getFilterVals = (item) => {

	const filterVals = {};

	// Loop through all filter fields and generate object of selected values
	[].forEach.call(item.querySelectorAll('[data-filters] [data-select]'), function(filterFld) {
		// Add field name/value to object
		filterVals[filterFld.name] = filterFld.value;
	});

	// If specific date HAS been chosen
	if (item.dataset.dateChosen == "true") {
		filterVals.date = item.querySelector("[data-specific-date]").value;
	}

	console.log(filterVals);

	return filterVals;
}

const getView = (item) => {
	return item.dataset.filteredEventsList;
}

const switchView = (item) => {
	// Get current view
	const currView = getView(item);

	// Calculate what new view should be
	const newView = (currView == "grid") ? "calendar" : "grid";

	// Get view data objects
	const newViewData = views.find(function(item) {
		return item.id === newView;
	});
	const altViewData = views.find(function(item) {
		return item.id === currView;
	});

	// Change view text where applicable
	item.dataset.filteredEventsList = newViewData.id;
	item.querySelector("[data-events-view-switcher-link-type]").innerHTML = altViewData.name;

	// Get html for this view
	getEvents(item);
}

const getEvents = (item) => {
	const filterVals = getFilterVals(item);
	const view       = getView(item);

	// Call to get html
	axios.get(baseUrl + 'actions/events-module/default/get-events', {
		params: {
			date: filterVals.date,
			category: filterVals.category,
			location: (filterVals.hasOwnProperty('location')) ? filterVals.location : 'all',
			view: view
		}
	})
	.then(function (response) {
		// handle success
		console.log(response);

		item.querySelector("[data-events-view-switcher-content]").innerHTML = response.data.html;
		item.querySelector("[data-events-view-switcher-total]").innerHTML   = response.data.total;

		elementary();
	});

	updateUrl(filterVals, view);
}

const updateUrl = (filterVals, view) => {

	// Generate new querystring based on filter values
	let params  = filterVals;
	params.view = view;

	const qs = Object.keys(params).map(key => key + '=' + params[key]).join('&');

	// Update url
	history.pushState('', '', window.location.href.split('?')[0] + '?' + qs);
}

export default FilteredEventsLists;